import { defineMessages } from 'react-intl';

export default defineMessages({
  headline: {
    id: 'LOGIN_LOGOUT_HEADLINE',
    defaultMessage: 'Sie sind jetzt ausgeloggt!',
  },
  comeback: {
    id: 'LOGIN_LOGOUT_COMEBACK',
    defaultMessage: 'Wenn Sie XING weiter nutzen wollen, {loginLink}.',
  },
  loginLinkText: {
    id: 'LOGIN_LOGOUT_LOGIN_LINK_TEXT',
    defaultMessage: 'loggen Sie sich bitte erneut ein',
  },
});
